import { AxiosError, isAxiosError } from "axios";

// error can be a string here because the Input components re-uses this error extraction mechanism
export const getErrorMessage = (error?: Error | AxiosError | AlertError | string, fallbackErrorMessage?: string) => {
  if (typeof error === "string") {
    return error;
  }

  if (isAxiosError(error) && error.response?.data?.errorMessage) {
    return error.response.data.errorMessage;
  }

  if (error instanceof AlertError) {
    return error.messageToDisplay;
  }

  if (fallbackErrorMessage) {
    return fallbackErrorMessage;
  }

  return "Something has gone wrong. Please try again later.";
};

class AlertError extends Error {
  messageToDisplay: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(messageToDisplay: string, ...params: any[]) {
    super(...params);
    this.messageToDisplay = messageToDisplay;

    // Maintaining proper stack trace (only on V8 engines like Node.js/Chrome)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AlertError);
    }
  }
}

export { AlertError };
